import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getColorByFilterAndResponse } from 'services/colorService'; // Importe a função que obtém a cor

const Legenda = ({ legendData, selectedRede, currentColor }) => {
	// Filtrar os dados da legenda com base na rede selecionada
	const filteredLegendData = legendData.filter(item => !selectedRede || item.rede === selectedRede);

	// Calcular o total com base nos dados filtrados
	const totalItems = filteredLegendData.reduce((total, item) => total + 1, 0);

	return (
			<div className="legenda" style={{ backgroundColor: 'rgba(83, 108, 149, 0.5)', padding: '1em', borderRadius: '8px' }}>
					<p style={{fontSize: '14px'}}>Nível dos problemas relacionados  ao consumo de crack</p>
					<ul style={{ listStyleType: 'none', padding: 0 }}>
							{filteredLegendData
									.filter(item => item.resposta !== '')
									.reduce((acc, curr) => {
											if (!acc.find(item => item.resposta === curr.resposta)) {
													acc.push(curr);
											}
											return acc;
									}, [])
									.sort((a, b) => a.resposta.localeCompare(b.resposta))
									.map((item, index) => {
											const itemCount = filteredLegendData.filter(data => data.resposta === item.resposta).length;
											if (itemCount > 0) {
													// Use a função de cor do serviço ao invés de `item.cor_resposta`
													const color = getColorByFilterAndResponse(item.rede, item.resposta);
													return (
															<li key={index} style={{ backgroundColor: `${color}`, color: '#fff', position: 'relative' }}>
																	{currentColor === color && <ArrowBackIcon style={{ position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)', color: 'var(--branco)' }} />}
																	{item.resposta} ({itemCount})
															</li>
													);
											} else {
													return null;
											}
									})}
							<li style={{ backgroundColor: 'var(--branco)', color: 'var(--preto)' }}> Total ({totalItems})</li>
					</ul>
			</div>
	);
};

export default Legenda;
